import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

import OrdersTable from '../components/orders-table/orders-table';
import {
  fetchUserOrders,
  setInitialOrders,
  setOrdersFilter,
  setPage,
} from '../store/actions/orders';
import { RootState } from '../types';

const formatTime = (date: string, fTime: string) =>
  format(new Date(date), fTime, { locale: ru });

const UserOrdersContainer: React.FC = () => {
  const [timestamp, setTimestamp] = useState(Date.now());
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const orders = useSelector((state: RootState) => state.orders);

  useEffect(() => {
    dispatch(setInitialOrders());
    setTimestamp(Date.now());
  }, [location.pathname]);

  const onTableItemClick = (id: number) => {
    history.push(`/orders/${id}`);
  };

  const onPaginate = () => {
    dispatch(setPage(orders.data.filters.page.number + 1));
    dispatch(fetchUserOrders({ concat: true }));
  };

  const formattedProps = Object.values(orders.data.orders).map((item) => ({
    id: item.id,
    refNumber: item.refNumber,
    title:
      orders.data.filters.role === 'RECIPIENT'
        ? item.initiator
        : item.recipient,
    inn: item.recipientTIN,
    count: item.releasedCountItem,
    totalCount: item.totalCountItem,
    sum: item.value,
    status: item.status,
    date: formatTime(item.openDate, 'dd MMM yyyy'),
    time: formatTime(item.openDate, 'HH:mm'),
  }));

  return (
    <OrdersTable
      key={timestamp}
      loading={orders.loading.orders}
      showBottomAction={!orders.data.pagination.isLast}
      onPaginateBtnClick={onPaginate}
      filters={orders.data.filters}
      onFilerChange={(name, direction) => {
        dispatch(setOrdersFilter({ type: name, value: direction }));
        dispatch(setPage(0));
        dispatch(fetchUserOrders());
      }}
      onItemClick={onTableItemClick}
      data={formattedProps}
      count={orders.data.filters.page.size}
      total={orders.data.pagination.total}
      specialFields={orders.data.pagination.specialFields}
    />
  );
};

export default UserOrdersContainer;
